import React from 'react';
import moment from 'moment';
import get from 'lodash/get';
import { FunctionField } from 'react-admin';
import { getZ3PConfigValue } from '../helper';

const formatDateTime = (dateString, startTimeString, endTimeString) => {
  const date = moment(dateString).format('YYYY-MM-DD');
  const startTime = moment(startTimeString, 'HH:mm:ss').format('hh:mm A');
  if (endTimeString != '') {
    const endTime = moment(endTimeString, 'HH:mm:ss').format('hh:mm A');
    return (
      <div>
        <span className="appointment_date">{date}</span>
        <br />
        <span className="appointment_time">
          {startTime} To {endTime}
        </span>
      </div>
    );
  }
  return `${date} | ${startTime}`;
};
const schedulingSystem = getZ3PConfigValue('scheduling_system');
const AppointmentTimeField = (props) => (
  <FunctionField
    {...props}
    render={(record) =>
      record &&
      formatDateTime(
        record.date,
        schedulingSystem === 'availability_windows'
          ? record.planned_arrival_time
          : record.confirmed_appointment_start_time,
        schedulingSystem === 'availability_windows'
          ? record.planned_departure_time
          : '',
      )
    }
  />
);

export default AppointmentTimeField;
